import React from "react";
import { useQaLabel, SaddleSelections, Paragraph } from "@tvg/design-system";
import {
  Container,
  ScratchedContainer,
  WinningTimeContainer
} from "./styled-components";
import { ScratchedRunnerResultProps } from "./types";

const ScratchedRunnersResult = ({
  scratchedRunnersSelection,
  winningTime,
  qaLabel = "scratched-runner-result"
}: ScratchedRunnerResultProps) => {
  const scratchedRunnersResultQaLabel = useQaLabel(qaLabel);

  return (
    <Container {...scratchedRunnersResultQaLabel}>
      <ScratchedContainer>
        {scratchedRunnersSelection.length > 0 && (
          <>
            <Paragraph qaLabel="scratched-runner-result" fontFamily="medium">
              Scratched
            </Paragraph>
            <SaddleSelections
              isDark={false}
              selections={scratchedRunnersSelection}
              showBetType={false}
            />
          </>
        )}
      </ScratchedContainer>
      <WinningTimeContainer>
        {winningTime ? (
          <>
            <Paragraph qaLabel="winning-time-runner-result" fontFamily="medium">
              Winning Time
            </Paragraph>
            <Paragraph qaLabel="winning-time-value-runner-result">
              {winningTime}
            </Paragraph>
          </>
        ) : null}
      </WinningTimeContainer>
    </Container>
  );
};

export default ScratchedRunnersResult;
